import { toast } from '@treneo/shared/ui';
import { extractRtkQueryErrorMessages } from '@treneo/shared/utils';

export const handleMutationError = (
  error: unknown,
  defaultErrorKey: string,
  t: (key: string) => string
): void => {
  const messages = extractRtkQueryErrorMessages(error, defaultErrorKey);
  const toShow =
    messages.length > 0 && messages[0] !== 'target must be an object'
      ? messages
      : [defaultErrorKey];
  const translated = toShow.map(key => t(key));
  toast.error(translated.length > 1 ? translated.join('\n') : translated[0]);
};
